import {
  PaymentCardProductType,
  PaymentCardStatusFilter,
} from '__generated__/GQL';

type StatusFilter = `${PaymentCardStatusFilter}`;
const possibleStatusFilter: StatusFilter[] = Object.values(
  PaymentCardStatusFilter,
);
const isStatusFilter = (status: string): status is PaymentCardStatusFilter =>
  possibleStatusFilter.includes(status as PaymentCardStatusFilter);

export const parseStatusList = (status: string[]): PaymentCardStatusFilter[] =>
  status.filter(isStatusFilter);

export const DEFAULT_STATUS = parseStatusList([
  'LOCKED',
  'ACTIVE',
  'INACTIVE',
  'CREATED',
] satisfies StatusFilter[]);

const possibleProductTypeFilter: Array<`${PaymentCardProductType}`> =
  Object.values(PaymentCardProductType);

const isProductTypeFilter = (
  status: string,
): status is PaymentCardProductType =>
  possibleProductTypeFilter.includes(status as PaymentCardProductType);

export const parseProductTypeList = (
  productType: string[],
): PaymentCardProductType[] => productType.filter(isProductTypeFilter);
